import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* BRAND */}
        <div className="footer-brand">
          <h3>Mongnis Prime</h3>
          <p>
            Premium handcrafted cakes made with intention, balance,
            and an obsessive attention to detail.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-links">

          <a
            href="https://instagram.com/mongnisprime"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
        </div>

      </div>

    <div className="footer-bottom">
  <span>© 2025 Mongnis Prime</span>

  <span className="footer-dot">•</span>

  <a
    href="https://almondsoftwares.in"
    target="_blank"
    rel="noopener noreferrer"
    className="dev-credit"
  >
    Developed by Almond Softwares
  </a>
</div>


       
      
    </footer>
  );
};

export default Footer;
